import { useMutation } from "@tanstack/react-query";
import { buildUrl, toastServerError } from "helpers";
import { ApiError, ApiServiceError, instance } from "libs/api";

import { SandboxMessageResult, SandboxSession } from "../../aiAgents.types";
import {
  AiAssistantSubRoute,
  ApiRoutesAiAssistants
} from "../../constants/enums";

const sandboxBase = (assistantId: string) =>
  buildUrl(
    ApiRoutesAiAssistants.Assistants,
    assistantId,
    AiAssistantSubRoute.SandboxSessions
  );

interface SendMessageVars {
  sessionId: string;
  text: string;
}

export const useSandbox = (assistantId: string) => {
  const createSession = useMutation<
    SandboxSession,
    ApiServiceError<ApiError>,
    void
  >({
    mutationFn: async () => await instance.post(sandboxBase(assistantId)),
    onError: toastServerError
  });

  const sendMessage = useMutation<
    SandboxMessageResult,
    ApiServiceError<ApiError>,
    SendMessageVars
  >({
    mutationFn: async ({ sessionId, text }) =>
      await instance.post(
        buildUrl(sandboxBase(assistantId), sessionId, "messages"),
        { text }
      ),
    onError: toastServerError
  });

  const resetSession = useMutation<
    { success: boolean },
    ApiServiceError<ApiError>,
    string
  >({
    mutationFn: async (sessionId) =>
      await instance.delete(buildUrl(sandboxBase(assistantId), sessionId)),
    onError: toastServerError
  });

  return { createSession, sendMessage, resetSession };
};
